import { Injectable } from '@angular/core';
import { HttpClientService } from '../http-client/http-client.service';
import { Subscriber } from 'rxjs/Subscriber';
import { Observable } from 'rxjs/Observable';
import { Service } from '../service';
import { EventDto } from '../../models/event/event';
import { SchoolScheduleEvent } from '../../models/event/dto/schoolScheduleEvent';

@Injectable()
export class EventService extends Service {


    public events: EventDto[];
    public eventsObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.events = [];
        this.eventsObject = {};
    }

    public getAll(): Observable<EventDto[]> {
        if (!!this.events && this.events.length > 0) {
            return Observable.create((observer: Subscriber<EventDto[]>) => {
                observer.next(this.events);
                observer.complete();
            });
        }
        const url = 'schoolschedule/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                for (const event of r.Result) {
                    event.FinishDate = new Date(event.FinishDate + 'Z');
                    event.StartDate = new Date(event.StartDate + 'Z');
                }

                this.events = r.Result;
                console.log('this.events', this.events);
                this.eventsObject = this.events.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('CurriculumService > getAll > response', r);
            }
            return this.events;
        }).catch(this.handleError);
    }


    public getScheduleByDivision(divisionId): Observable<EventDto[]> {
        // if (!!this.events && this.events.length > 0) {
        //     return Observable.create((observer: Subscriber<EventDto[]>) => {
        //         observer.next(this.events);
        //         observer.complete();
        //     });
        // }
        const url = 'schoolschedule/bydivision/' + divisionId;
        return this.http.get(url).map(response => {
            const r = response.json();
            let events = [];
            if (r.ResultCode === 1) {
                for (const event of r.Result) {
                    event.FinishDate = new Date(event.FinishDate + 'Z');
                    event.StartDate = new Date(event.StartDate + 'Z');
                }
                events = r.Result;
            } else {
                console.error('EventService > getScheduleByDivision > response', r);
            }
            return events;
        }).catch(this.handleError);
    }

    public add(data: any) {
        const url = 'schoolschedule/add';
        return this.http.post(url, data).map(response => response.json())
            .catch(this.handleError);
    }

    public addSchoolSchedule(data: SchoolScheduleEvent) {
        const url = 'schoolschedule/addSchoolSchedule';
        return this.http.post(url, data).map(response => response.json())
            .catch(this.handleError);
    }

    public delete(id: number) {
        const url: string = 'schoolschedule/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/events/event.service.ts